import { setResetInterviewFormModal } from "../../../../../store/workspace/slice";
import { ResetSquareIcon } from "../../../../../assets/icons";
import { useDispatch } from "../../../../../store/store";
import Modal from "../../../../../components/Modal";
import styles from './style.module.scss';

interface Props {
    resetFunc: () => void;
};

export default function ConfirmResetInterviewForm(props: Props) {
    const { resetFunc } = props;
    const dispatch = useDispatch();

    const reset = () => {
        resetFunc();
        dispatch(setResetInterviewFormModal(false));
    };

    return (
        <Modal
            size='md'
            title='Reset to default list'
            icon={<ResetSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setResetInterviewFormModal(false))}
            actions='both'
            restrictActionsWidth
            dismissButton={{
                text: 'Keep it',
                type: 'Outline-Primary',
                onClick: () => dispatch(setResetInterviewFormModal(false)),
            }}
            confirmButton={{
                text: 'Reset',
                type: 'Error',
                onClick: reset,
            }}
        >
            <div className={styles.content}>
                <span className={styles.content_title}>
                    Are you sure you want to reset your list to the default settings?
                </span>
                <p className={styles.content_attention}>
                    <b>Note:</b> Resetting your list will erase any changes you’ve made.
                </p>
            </div>
        </Modal>
    )
};
